import React, { useState, useEffect, useRef } from "react"
import { DOCTORS, INSTITUTES } from "../constants"
import {
  Search,
  ArrowRight,
  User,
  ShieldCheck,
  Activity,
  Users,
  BadgeCheck,
  Microscope,
  ChevronRight,
  Target,
  Sparkles,
  MapPin
} from "lucide-react"
import { Link } from "react-router-dom"

const DoctorSearch = () => {
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedInstitute, setSelectedInstitute] = useState("All")
  const observerRef = useRef(null)

  useEffect(() => {
    document.title = "VCNR Clinical Board | Find a Specialist"
    window.scrollTo(0, 0)

    observerRef.current = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active")
          }
        })
      },
      { threshold: 0.1 }
    )

    document.querySelectorAll(".reveal").forEach(el => {
      observerRef.current?.observe(el)
    })

    return () => observerRef.current?.disconnect()
  }, [searchTerm, selectedInstitute])

  const filteredDoctors = DOCTORS.filter(doc => {
    const matchesSearch =
      doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.specialty.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesInstitute =
      selectedInstitute === "All" || doc.institute === selectedInstitute
    return matchesSearch && matchesInstitute
  })

  return (
    <div className="bg-white min-h-screen">
      {/* --- CLINICAL BOARD COMMAND BANNER --- */}
      <section className="relative pt-48 pb-40 bg-slate-900 overflow-hidden">
        {/* Technical Overlays & Background Image */}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-transparent z-10"></div>
          <div className="absolute inset-0 hospital-grid opacity-[0.12] z-20 pointer-events-none"></div>

          {/* Main Background Asset - Reverted to Previous High-Res Lab Image */}
          <div className="absolute top-0 right-0 w-full h-full opacity-70">
            <img
              src="https://images.unsplash.com/photo-1551601651-2a8555f1a136?auto=format&fit=crop&q=80&w=2400"
              alt="Advanced Clinical Hub"
              className="w-full h-full object-cover transition-all duration-[5s] grayscale-[30%] hover:grayscale-0"
            />
          </div>

          {/* Diagnostic Scanning Animation */}
          <div className="absolute inset-0 z-30 pointer-events-none overflow-hidden">
            <div className="scanning-line !h-[2px] !opacity-50 !bg-vcnr-brand !shadow-[0_0_20px_#4f46e5]"></div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-40">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left: Typography & Controls */}
            <div className="max-w-xl reveal">
              {/* <div className="inline-flex items-center gap-3 px-4 py-2 bg-vcnr-brand/20 border border-vcnr-brand/30 backdrop-blur-md rounded-full mb-8">
                <ShieldCheck
                  size={14}
                  className="text-vcnr-brand animate-pulse"
                />
                <span className="text-[10px] font-black uppercase tracking-[0.3em] text-white">
                  Clinical Governance Tier-1
                </span>
              </div> */}
              <h1 className="text-5xl md:text-6xl font-semibold text-white   mb-6">
                Clinical <br />
                <span className="text-vcnr-brand ">
                  Faculty.
                </span>
              </h1>
              <p className="text-slate-200 text-lg mb-8">
                Access VCNR’s global network of board-certified medical
                specialists. Our faculty is organized into 9 specialized
                institutes for hyper-focused tertiary care.
              </p>

              {/* Live HUD Stats */}
              {/* <div className="grid grid-cols-2 gap-6 reveal stagger-2">
                <div className="p-6 bg-white/5 border border-white/10 backdrop-blur-xl rounded-2xl group hover:border-vcnr-brand transition-all">
                  <div className="flex items-center gap-4 mb-2">
                    <div className="w-10 h-10 bg-vcnr-brand/10 rounded-lg flex items-center justify-center text-vcnr-brand">
                      <Users size={20} />
                    </div>
                    <div className="text-2xl font-black text-white">50+</div>
                  </div>
                  <div className="text-[9px] font-black text-slate-500 uppercase tracking-widest">
                    Board Specialists
                  </div>
                </div>
                <div className="p-6 bg-white/5 border border-white/10 backdrop-blur-xl rounded-2xl group hover:border-vcnr-brand transition-all">
                  <div className="flex items-center gap-4 mb-2">
                    <div className="w-10 h-10 bg-vcnr-brand/10 rounded-lg flex items-center justify-center text-vcnr-brand">
                      <Activity size={20} />
                    </div>
                    <div className="text-2xl font-black text-white">99.4%</div>
                  </div>
                  <div className="text-[9px] font-black text-slate-500 uppercase tracking-widest">
                    Success Rating
                  </div>
                </div>
              </div> */}
            </div>

            {/* Right: Asset Visualization (Desktop Only) */}
            {/* <div className="hidden lg:block relative reveal stagger-3 group">
              <div className="absolute -inset-4 border border-white/10 rounded-[3.5rem] group-hover:border-vcnr-brand transition-colors duration-1000"></div>

              <div className="relative h-[550px] w-full rounded-[3rem] overflow-hidden border-[12px] border-slate-900 shadow-2xl bg-slate-800">
              
                <div className="absolute inset-0 z-20 pointer-events-none bg-gradient-to-t from-slate-900/60 to-transparent"></div>
          
                <img
                  src="https://images.unsplash.com/photo-1559839734-2b71f1e59816?auto=format&fit=crop&q=80&w=1200"
                  className="w-full h-full object-cover grayscale brightness-110 group-hover:grayscale-0 transition-all duration-[2s] group-hover:scale-105"
                  alt="Specialist Hub"
                /> 

             
                <div className="absolute top-8 left-8 z-30">
                  <div className="w-12 h-12 bg-vcnr-brand rounded-xl flex items-center justify-center text-white shadow-2xl animate-float">
                    <Target size={24} />
                  </div>
                </div>

                <div className="absolute bottom-8 left-8 right-8 z-30">
                  <div className="bg-white/95 backdrop-blur-2xl p-6 rounded-[2rem] border border-white shadow-2xl">
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-[10px] font-black text-vcnr-brand uppercase tracking-widest">
                        Operational Hub Active
                      </span>
                      <span className="flex h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
                    </div>
                    <div className="flex items-center gap-6">
                      <div className="flex -space-x-3">
                        {[1, 2, 3, 4].map(i => (
                          <div
                            key={i}
                            className="w-10 h-10 rounded-full border-2 border-white bg-slate-100 overflow-hidden"
                          >
                            <img
                              src={`https://i.pravatar.cc/100?img=${i + 10}`}
                              className="w-full h-full object-cover"
                              alt="Dr"
                            />
                          </div>
                        ))}
                      </div>
                      <div className="text-xs font-bold text-slate-900 uppercase tracking-tight">
                        Clinical Board <br />{" "}
                        <span className="text-slate-400 font-medium">
                          UNIT_DIRECTORY_V3
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* --- DATABASE QUERY INTERFACE --- */}
      <section className="relative z-50 -mt-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white p-5 rounded-[2.5rem] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.15)] border border-slate-100 flex flex-col lg:flex-row gap-5 reveal stagger-3">
            <div className="flex-1 relative group">
              <div className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-vcnr-brand transition-colors">
                <Search size={22} />
              </div>
              <input
                type="text"
                placeholder="SEARCH REGISTRY BY NAME OR SPECIALTY..."
                className="w-full pl-16 pr-8 py-6 bg-slate-50 border-none rounded-2xl text-[14px] font-semi   focus:ring-2 focus:ring-vcnr-brand/20 focus:outline-none transition-all placeholder:text-slate-400"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="lg:w-96 relative group">
              <div className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-vcnr-brand transition-colors pointer-events-none">
                <Microscope size={22} />
              </div>
              <select
                className="w-full pl-16 pr-12 py-6 bg-slate-50 border-none rounded-2xl text-[14px] font-semibold  focus:ring-2 focus:ring-vcnr-brand/20 focus:outline-none transition-all appearance-none cursor-pointer"
                value={selectedInstitute}
                onChange={e => setSelectedInstitute(e.target.value)}
              >
                <option value="All">All Institutes</option>
                {INSTITUTES.map(inst => (
                  <option key={inst.id} value={inst.name}>
                    {inst.name.replace("VCNR ", "")}
                  </option>
                ))}
              </select>
              <ChevronRight
                size={16}
                className="absolute right-6 top-1/2 -translate-y-1/2 text-slate-300 group-hover:text-vcnr-brand transition-colors pointer-events-none rotate-90"
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- SPECIALIST PROFILE GRID --- */}
      <section className="py-32 px-6 bg-slate-50/50">
        <div className="max-w-7xl mx-auto">
          {filteredDoctors.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {filteredDoctors.map((doc, index) => {
                const isOrthopedics = doc.specialty
                  .toLowerCase()
                  .includes("orthopedic")
                return (
                  <div
                    key={doc.id}
                    className={`group relative bg-white border border-slate-100 p-6 rounded-[2.5rem] transition-all duration-700 hover:shadow-[0_40px_80px_-20px_rgba(79,70,229,0.15)] reveal stagger-${(index %
                      4) +
                      1} ${isOrthopedics ? "ring-1 ring-vcnr-brand/20" : ""}`}
                  >
                    {/* Unit ID Accent */}
                    <div className="absolute top-6 right-6 text-[9px] font-black text-slate-200 group-hover:text-vcnr-brand transition-colors uppercase tracking-[0.2em] select-none">
                      REF_{index + 1}
                    </div>

                    {/* Image Hub */}
                    <div className="relative h-80 rounded-[2rem] overflow-hidden mb-8 bg-slate-100">
                      <div className="scanning-line opacity-0 group-hover:opacity-100 transition-opacity"></div>
                      <img
                        src={doc.image}
                        alt={doc.name}
                        className="w-full h-full object-cover grayscale brightness-90 group-hover:grayscale-0 group-hover:brightness-100 group-hover:scale-110 transition-all duration-[1.5s]"
                      />

                      {/* {isOrthopedics && (
                        <div className="absolute top-4 left-4 bg-vcnr-brand text-white px-3 py-1.5 rounded-full text-[8px] font-black uppercase tracking-widest animate-vital-pulse flex items-center gap-2 z-10 shadow-lg">
                          <Target size={12} className="animate-spin" />{" "}
                          Precision Core
                        </div>
                      )} */}

                      <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-md px-4 py-2 rounded-xl border border-white/50 shadow-xl z-10">
                        <div className="text-[12px] font-semibold text-slate-900 ">
                          {doc.exp} 
                        </div>
                      </div>
                    </div>

                    {/* Info Hub */}
                    <div className="px-2">
                      
                      <h3 className="text-xl font-semibold text-slate-900  mb-2 group-hover:text-vcnr-brand transition-colors">
                        {doc.name}
                      </h3>
                      <div className="text-sm font-bold text-slate-500 flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-vcnr-brand/30"></div>
                        {doc.specialty}
                      </div>

                      <div className="pt-6 border-t border-slate-50 flex items-center justify-between mb-8">
                        <div className="flex flex-col gap-1">
                          <span className="text-[10px] font-semibold text-slate-300 uppercase tracking-widest">
                            Clinical Unit:
                          </span>
                          <span className="text-[14px] font-semibold text-slate-600  max-w-[120px]">
                            {doc.institute.replace("VCNR ", "")}
                          </span>
                        </div>
                        
                      </div>

                      <Link
                        to="/booking"
                        className="w-full py-5 bg-slate-900 text-white rounded-2xl text-[14px] font-semibold flex items-center justify-center gap-3 hover:bg-vcnr-brand hover:scale-[1.02] active:scale-95 transition-all group/btn shadow-xl shadow-slate-900/10"
                      >
                        Secure Clinical Slot{" "}
                        <ArrowRight
                          size={16}
                          className="group-hover/btn:translate-x-2 transition-transform"
                        />
                      </Link>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="py-40 flex flex-col items-center text-center reveal">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center text-slate-200 mb-8 border-4 border-slate-50 shadow-2xl">
                <User size={48} />
              </div>
              <h3 className="text-3xl font-semibold  text-slate-900 mb-4">
                Registry Entry Not Found.
              </h3>
              <p className="text-slate-500 max-w-sm mb-12 italic">
                The clinical specialist or specialty query did not resolve.
                Please refine your database parameters.
              </p>
              <button
                onClick={() => {
                  setSearchTerm("")
                  setSelectedInstitute("All")
                }}
                className="px-12 py-5 bg-slate-900 text-white text-[14px] font-semibold hover:bg-vcnr-brand transition-all rounded-2xl shadow-xl"
              >
                Reset Faculty Query
              </button>
            </div>
          )}
        </div>
      </section>

      {/* --- EMERGENCY REDIRECT --- */}
      <section className="pb-32 px-6 reveal">
        <div className="max-w-7xl mx-auto">
          <div className="bg-slate-900 rounded-[3.5rem] p-12 md:p-24 text-white relative overflow-hidden group">
            <div className="absolute inset-0 opacity-20 hospital-grid group-hover:scale-110 transition-transform duration-[20s]"></div>
            <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-16">
              <div className="max-w-2xl">
                <div className="inline-flex items-center gap-3 px-4 py-2 bg-red-600/10 border border-red-600/20 rounded-full mb-8">
                  <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
                  <span className="text-[14px] font-semibold  text-red-500">
                    Emergency Protocol Active
                  </span>
                </div>
                <h2 className="text-4xl md:text-[3rem]  font-semibold text-slate-900 mb-8 leading-tight text-white">
                  Can't Find Your <br />{" "}
                  <span className="text-vcnr-brand">
                    Specific Unit?
                  </span>
                </h2>
                <p className="text-slate-200 text-xl ">
                  Our medical triage agents are available 24/7 to assist in
                  routing your clinical requirements to the correct board
                  specialist.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-6 shrink-0">
                <a
                  href="tel:1066"
                  className="px-14 py-6 bg-red-600 text-white rounded-2xl font-semibold  text-[14px]  hover:bg-red-700 transition-all hover:scale-110 shadow-2xl shadow-red-600/20 flex items-center gap-3"
                >
                  <Activity size={18} /> Emergency: 1066
                </a>
                <Link
                  to="/booking"
                  className="px-14 py-6 bg-white text-slate-900 rounded-2xl font-semibold  text-[14px] hover:bg-vcnr-brand hover:text-white transition-all hover:scale-110 shadow-2xl"
                >
                  General Inquiry
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>


        <div className="bg-slate-900 py-10 px-6">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
                  <div className="flex items-center gap-6">
                    <div className="w-12 h-12 bg-vcnr-brand/20 rounded-xl flex items-center justify-center text-vcnr-brand">
                      <MapPin size={24} />
                    </div>
                    <div>
                      <div className="text-[12px] font-semibold text-slate-400 uppercase tracking-widest mb-1">
                        Facility Address
                      </div>
                      <div className="  text-white uppercase ">
                        Opp Binnamangala Nursery, B.H. Road, Nelamangala - 562123,
                        Bangalore.
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <a
                      href="/booking"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-8 py-3 bg-white text-slate-900 rounded-xl text-[12px] font-bold uppercase  hover:bg-vcnr-brand hover:text-white transition-all"
                    >
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default DoctorSearch
